import React from 'react';
import { Row, Col } from 'react-bootstrap';

import Button from 'src/components/button';
import styles from './Styles.module.scss';
import { toast } from 'react-toastify';
import { localizedStrings } from '../../../../../../localization';
import Toast from 'src/components/toast';
import Text from 'src/components/text';
class DeleteCustomFieldView extends React.Component {
  constructor(props) {
    super(props);

    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);


    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedCustomFields = this.localizedSettings.account.custom_fields;
  }

  _handleDeleteClick() {
    this.props.deleteCustomField(this.props.item.id).then(() => {
      if (this.props.onDeletion) {
        this.props.onDeletion();
        toast(
          <Toast.Sucess
            message = {localizedStrings.formatString(this.localizedCustomFields.delete_slider.toast.description, {
              name: this.props.item.name
            })}            
          /> , {
            autoClose: 3000,
        })
      } 
    });
  }

  _handleCancelClick() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <Row className={styles.top}>
          <Col sm={8} className={styles.column}>
            <div className={styles.heading}>{this.localizedCustomFields.delete_slider.title}</div>
            <div className={styles.label}>
              {this.props.item &&
                <h2 className={styles.customFieldName}>{`${this.props.item.name} `}</h2>}
                </div>

            <p className={styles.description}>
              {this.localizedCustomFields.delete_slider.sub_text}
            </p>
            {this.props.item && (
              <Text className={styles.customFieldName} text={this.props.item.name} tooltip={{placement: "auto"}} />
              )}
          </Col>
        </Row>
        <Row>
              <div  className={styles.buttonTray}>

            <Button
              text={this.props.deleting ? `${this.localizedCommonsActions.deleting}...` : this.localizedCommonsActions.confirm}
            disabled={this.props.deleting}
             variant='primary'   
            onClick={() => { this._handleDeleteClick() }}

            />


            <Button
              text={this.localizedCommonsActions.cancel}
              disabled={this.props.deleting}
              onClick={() => { this._handleCancelClick() }}
            />
</div>
       
        </Row>
      </div>
    );
  }
}
export default DeleteCustomFieldView;